module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00019"
    }
  }, [_c('a', {
    staticClass: "calibre23",
    attrs: {
      "id": "CHAPTER_II"
    }
  }), _vm._v("CHAPTER II.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('strong', {
    staticClass: "calibre4"
  }, [_vm._v("A RACE FOR THE RAILROAD CUP.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Young Blake had now been in Euston two years, and was, among the boys,\ndecidedly the most popular fellow in the place. He was a slightly-built\nchap; but with muscles like steel wires, and possessed of wonderful\nagility and powers of endurance. He excelled in all athletic sports, was a\ncapital boxer, and at the same time found little difficulty in maintaining\na good rank in his classes. He had taken to bicycling from the very first,\nand quickly became an expert rider, though he had never gone in for\nracing. It was therefore a great surprise, even to his friends, when, on\nthe very day before the race meeting, he entered his name for the event\nthat was to result in the winning or losing of the Railroad Cup. It would\nnot have been so much of a surprise had anybody known of his conversation,\na"), _c('span', {
    attrs: {
      "id": "pgepubid00020",
      "title": "[Pg 9]"
    }
  }), _vm._v(" few weeks before, with Eltje Vanderveer, the railroad president’s only\ndaughter. She was a few months younger than Rod, and ever since he had\njumped into the river to save her pet kitten from drowning, they had been\nfast friends.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So, when in talking of the approaching meeting, Eltje had said, “How I\nwish you were a racer, and could win our cup, Rod,” the boy instantly made\nup his mind to try for it. He only answered, “Do you? Well, perhaps I may\ngo in for that sort of thing some time.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Then he began training, so secretly that nobody but Dan, a stable boy on\nhis uncle’s place and Rod’s most ardent admirer, was aware of it; but with\nsuch steady determination that on the eventful day of the great race his\nphysical condition was very nearly perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("He was on hand at the race track bright and early; for, as captain of the\nclub, Rod had a great deal to do in seeing that everything went smoothly,\nand in starting on time the dozen events that preceded the race for the\nRailroad Cup, which came last on the programme.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("While these earlier events were being run off"), _c('span', {
    attrs: {
      "id": "pgepubid00021",
      "title": "[Pg 10]"
    }
  }), _vm._v(" Snyder Appleby, faultlessly\nattired, sat in the grand stand beside his adopted father, and directly\nbehind President Vanderveer and his pretty daughter, to whom he tried to\nrender himself especially agreeable. He listened respectfully to the\nMajor’s stories, made amusing comments on the racers for Eltje’s benefit,\nand laughed heartily at the puns that her father was given to making.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“But how about your own race, Mr. Appleby?” asked Eltje. “Don’t you feel\nany anxiety concerning it? It is to be the hardest one of all, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Immensely flattered at being addressed as Mister Appleby, Snyder replied\ncarelessly, “Oh, yes! of course I am most anxious to win it, especially as\nyou are here to see it run; but I don’t anticipate much difficulty. Bliss\nis a hard man to beat; but I have done it before, and I guess I can do it\nagain.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Then you don’t think Rodman has any chance of winning?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Well, hardly. You see this is his first race, and experience goes a long\nway in such affairs. Still, he rides well, and it wouldn’t surprise me to\nsee him make a good third at the finish.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eltje smiled as she answered, “Perhaps he will"), _c('span', {
    attrs: {
      "id": "pgepubid00022",
      "title": "[Pg 11]"
    }
  }), _vm._v(" finish third; but it would\nsurprise me greatly to see him do so.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("This pretty girl, with the Dutch name, had such faith in her friend Rod,\nthat she did not believe he would ever be third, or even second, where he\nhad once made up his mind to be first.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Failing to catch her real meaning, Snyder replied: “Of course he may not\ndo as well as that; but he ought to. As captain of the club he ought to\nsustain the honor of his position, you know. If he doesn’t feel able to\ntake at least third place in a five-starter race, he should either resign,\nor keep out of the racing field altogether. Now I must leave you; for I\nsee I am wanted. You’ll wish me good luck, won’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes,” answered Eltje mischievously, “I wish you all the luck you\ndeserve.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Forced to be content with this answer, but wondering if there was any\nhidden meaning in it, Snyder left the grand stand, and strolled leisurely\naround to the dressing-room, lighting a cigarette as he went.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Hurry up!” shouted Rod, who was the soul of punctuality and was\nparticularly anxious that all the"), _c('span', {
    attrs: {
      "id": "pgepubid00023",
      "title": "[Pg 12]"
    }
  }), _vm._v(" events of this, his first race meeting,\nshould be started on time. “Hurry up. Our race will be called in five\nminutes, and you’ve barely time to dress for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Where’s my wheel?” asked Snyder, glancing over the dozen or more machines\nstacked at one side of the room, but without seeing his own.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“I haven’t seen it,” answered Rod, “but I supposed you had left it in some\nsafe place.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“So I did. I left it in the club house, where there would be no chance of\nanybody tampering with it; for I’ve heard of such things happening, but I\nordered Dan to have it down here in time for the race.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Do you mean to insinuate—” began Rod hotly; but controlling himself, he\ncontinued more calmly, “I didn’t know that you had given Dan any orders,\nand I sent him over to the house on an errand a few minutes ago. Never\nmind, though, I’ll go for your machine myself, and have it here by the\ntime you are dressed.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Without waiting for a reply, the young captain started off on a run, while\nhis adopted cousin began leisurely to undress, and get into his racing\ncostume."), _c('span', {
    attrs: {
      "id": "pgepubid00024",
      "title": "[Pg 13]"
    }
  }), _vm._v(" By the time he was ready, Rod had returned leading the beautiful\nmachine, which he had not ridden for fear lest some accident might happen\nto it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Then the race was called, and a pistol shot sent the five young athletes\nbending low over their handle-bars spinning down the course. They all wore\nthe club colors of scarlet and white; but from Rod’s bicycle fluttered the\nbit of blue ribbon that Dan had been sent to the young captain’s room to\nget, and which he had hastily knotted to the handle-bar of his machine\njust before starting. Eltje Vanderveer smiled and flushed slightly as she\nnoticed it, and then all her attention was concentrated upon the varying\nfortunes of the flying wheelmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("It was a five-mile race, and therefore a test of endurance rather than of\nstrength or skill. There were two laps to the mile, and for seven of these\nSnyder Appleby held an easy lead. His name was heard above all others in\nthe cheering that greeted each passing of the grand stand, though the\nothers were encouraged to stick to him and not give it up yet. That two of\nthem had no intention of giving it up, was shown at the end of the eighth\nlap, when the three leading wheels whirled past the grand"), _c('span', {
    attrs: {
      "id": "pgepubid00025",
      "title": "[Pg 14]"
    }
  }), _vm._v(" stand so nearly\nabreast that no advantage could be claimed for either one.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Now the cheering was tremendous; but the names of Rod Blake and Billy\nBliss were tossed from mouth to mouth equally with that of Snyder Appleby.\nAt the end of nine laps the champion of two years had fallen hopelessly\nbehind. His face wore a distressed look, and his breath came in painful\ngasps. Cigarettes had done their work with him, and his wind was gone. The\ntwo leaders were still abreast; but Rod had obtained the inside position,\nand if he could keep up the pace the race was his.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Eltje Vanderveer’s face was pale, and her hands were clinched with the\nintense excitement of the moment. Was her champion to win after all? Was\nher bit of blue ribbon to be borne triumphantly to the front? Inch by inch\nit creeps into a lead. Now they are coming down the home stretch. The\nspeed of that last spurt is wonderful. Nothing like it has ever been seen\nat the wind-up of a five-mile race on the Euston track. Looking at them,\nhead on, it is for a few seconds hard to tell which is leading. Then a\nsolitary shout for Rod Blake is heard. In an"), _c('span', {
    attrs: {
      "id": "pgepubid00026",
      "title": "[Pg 15]"
    }
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "Page_15",
      "title": "[Pg 15]"
    }
  })]), _vm._v("other moment it has swelled\ninto a perfect roar of cheering, and there is a tempest of tossing hats,\nhandkerchiefs, and parasols.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('a', {
    staticClass: "reference",
    attrs: {
      "id": "imgpg15"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "figcenter4"
  }, [_c('img', {
    staticClass: "calibre16",
    attrs: {
      "alt": "Image",
      "id": "id-6930260434403324029",
      "src": "Images/img0004.jpg",
      "title": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption1"
    }
  }, [_vm._v("rod blake wins by a length.—("), _c('em', {
    staticClass: "calibre19"
  }, [_vm._v("page "), _c('a', {
    staticClass: "reference",
    attrs: {
      "href": "#/Text/Section0006#Page_15"
    }
  }, [_vm._v("15")]), _vm._v(".")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rod Blake has won by a length, Billy Bliss is second, Snyder Appleby was\nsuch a bad third that he has gone to the dressing-room without finishing,\nand the others are nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The speed of the winning wheels cannot be checked at once, and as they go\nshooting on past the stand, the exhausted riders are seen to reel in their\nsaddles. They would have fallen but for the willing hands outstretched to\nreceive them. Dan is the first to reach the side of his adored young\nmaster, and as the boy drops into his arms, the faithful fellow says:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“You’ve won it, Mister Rod! You’ve won it fair and square; but you want to\nlook out for Mister Snyder. I heerd him a-saying bad things about you when\nhe passed me on that last lap, and I’m afeard he means some kind of\nmischief.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "pgepubid00027",
      "title": "[Pg 16]"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pg-boilerplate",
    attrs: {
      "id": "calibre_pb_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c71e0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0006.vue
// module id = 72
// module chunks = 0